/**
 * "Was this helpful?" feedback widget — posts a single helpful/not-helpful vote
 * to the article feedback endpoint, then swaps the prompt for a thank-you.
 */
function init($) {
    var $feedback = $('#blog-feedback');
    if (!$feedback.length) { return; }

    var feedbackSlug   = $feedback.data('slug');
    var feedbackLocale = $feedback.data('locale');
    var feedbackToken  = $feedback.data('feedback-token');
    var feedbackCsrf   = $feedback.data('csrf');
    var feedbackSent   = false;

    $feedback.on('click', '.blog-feedback__btn', function () {
        if (feedbackSent) { return; }

        var $btn      = $(this);
        var isHelpful = parseInt($btn.data('helpful'), 10) === 1;
        feedbackSent  = true;

        $feedback.find('.blog-feedback__btn').prop('disabled', true);
        $btn.addClass('blog-feedback__btn--selected');

        $.ajax({
            url         : '/' + feedbackLocale + '/blog/' + feedbackSlug + '/feedback',
            method      : 'POST',
            contentType : 'application/json',
            data        : JSON.stringify({
                is_helpful      : isHelpful,
                _feedback_token : feedbackToken,
                _csrf           : feedbackCsrf
            }),
            success: function (data) {
                if (data && data.status === 'ok') {
                    $feedback.find('h3').text(
                        typeof _t === 'function' ? _t('Thank you for your feedback!') : 'Thank you for your feedback!'
                    );
                } else {
                    // already_voted — intentional 24h limit to prevent vote manipulation
                    $feedback.find('h3').text(
                        typeof _t === 'function' ? _t('You have already voted.') : 'You have already voted.'
                    );
                }
                $feedback.find('.blog-feedback__buttons').hide();
            },
            error: function () {
                feedbackSent = false;
                $feedback.find('.blog-feedback__btn').prop('disabled', false);
                $btn.removeClass('blog-feedback__btn--selected');
            }
        });
    });
}

module.exports = { init };
